module.exports = __webpack_public_path__ + "img/search.da0d488b.svg";